import { render, staticRenderFns } from "./UpcomingHoliday.vue?vue&type=template&id=dd055b14&"
import script from "./UpcomingHoliday.vue?vue&type=script&lang=ts&"
export * from "./UpcomingHoliday.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UpcomingHoliday.vue"
export default component.exports